/**
 * userMe 接口类型定义
 */

/**
 * 用户角色枚举
 * -1: 未登录的角色
 * 0: 已登录未认证的角色
 * 1: 自雇医生
 * 2: 自雇助手
 * 3: 药师
 * 4: 普通医生
 * 5: 医护辅助人员
 */
export enum UserRole {
    Unauthenticated = -1,     // 未登录的角色
    Unverified = 0,           // 已登录未认证的角色
    SelfDoctor = 1,           // 自雇医生
    SelfAssistant = 2,        // 自雇助手
    Pharmacist = 3,           // 药师
    Doctor = 4,               // 普通医生
    MedicalAssistant = 5,     // 医护辅助人员
}

export interface IUserMeResponse {
    name: string;
    avatar: string;
    redirect_type: string;
    role: UserRole;
}